import "./myIcons.scss";

const LocalityIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-map-pin-plus-inside-icon lucide-map-pin-plus-inside menu-icon ${className}`}

>
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <path d="M12 7v6" />
    <path d="M9 10h6" />
  </svg>
);



const Dashboard=({size=24, color = "currentColor", className = ""})=>(
<svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <rect width="7" height="9" x="3" y="3" rx="1" />
                <rect width="7" height="5" x="14" y="3" rx="1" />
                <rect width="7" height="9" x="14" y="12" rx="1" />
                <rect width="7" height="5" x="3" y="16" rx="1" />
              </svg>
)

const Clients=({size=24, color = "currentColor", className = ""})=>(
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-handshake-icon lucide-handshake menu-icon ${className}`}
              >
                <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                <path d="m21 3 1 11h-2" />
                <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                <path d="M3 4h8" />
              </svg>
)



const AddClient = ({ size = 24, color = "currentColor", className = "", showPlus = true }) => (
  <div
    style={{
      position: "relative",
      display: "inline-block",
      width: size,
      height: size,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide lucide-handshake-icon lucide-handshake menu-icon ${className}`}
    >
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
      <path d="m21 3 1 11h-2" />
      <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
      <path d="M3 4h8" />
    </svg>

    {showPlus && (
      <span
        style={{
          position: "absolute",
          bottom: -4,
          right: -4,
          width: 16,
          height: 16,
          backgroundColor: "white",
          borderRadius: "50%",
          fontSize: 12,
          fontWeight: "bold",
          color: "red",
          textAlign: "center",
          lineHeight: "16px",
          boxShadow: "0 0 2px rgba(0,0,0,0.2)",
          pointerEvents: "none",
        }}
      >
        +
      </span>
    )}
  </div>
);




const Users=({size=24, color = "currentColor", className = ""})=>(
    <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-users-round-icon lucide-users-round menu-icon ${className}`}
              >
                <path d="M18 21a8 8 0 0 0-16 0" />
                <circle cx="10" cy="8" r="5" />
                <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
              </svg>
)

const BasketIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-shopping-cart-icon lucide-shopping-cart ${className}`}
  >
    <circle cx="8" cy="21" r="1" />
    <circle cx="19" cy="21" r="1" />
    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
  </svg>
);

const Buildersdata=({size=24, color = "currentColor", className = ""})=>(
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-database-icon lucide-database menu-icon ${className}`}
              >
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                <path d="M3 12A9 3 0 0 0 21 12" />
              </svg>


)

const Admindashboard=({size=24, color = "currentColor", className = ""})=>(
                  <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={size}
                  height={size}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={color}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`lucide lucide-lock-keyhole-icon lucide-lock-keyhole menu-icon ${className}`}
                >
                  <circle cx="12" cy="16" r="1" />
                  <rect x="3" y="10" width="18" height="12" rx="2" />
                  <path d="M7 10V7a5 5 0 0 1 10 0v3" />
                </svg>

)

const Logout=({size=24, color = "currentColor", className = ""})=>(
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <path d="m16 17 5-5-5-5" />
                <path d="M21 12H9" />
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              </svg>

)

const Newpost=({size=24, color = "currentColor", className = ""})=>(
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-list-plus-icon lucide-list-plus menu-icon ${className}`}
              >
                <path d="M11 12H3" />
                <path d="M16 6H3" />
                <path d="M16 18H3" />
                <path d="M18 9v6" />
                <path d="M21 12h-6" />
              </svg>

)


const Profile=({size=24, color = "currentColor", className = ""})=>(
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className= {`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <path d="M2 21a8 8 0 0 1 10.821-7.487" />
                <path d="M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                <circle cx="10" cy="8" r="5" />
              </svg>

)

const Inventory=({size=24, color = "currentColor", className = ""})=>(
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <rect x="3" y="5" width="6" height="6" rx="1" />
                <path d="m3 17 2 2 4-4" />
                <path d="M13 6h8" />
                <path d="M13 12h8" />
                <path d="M13 18h8" />
              </svg>


)

const Savedlist=({size=24, color = "currentColor", className = ""})=>(

                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className= {`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <rect width="7" height="7" x="3" y="3" rx="1" />
                <rect width="7" height="7" x="3" y="14" rx="1" />
                <path d="M14 4h7" />
                <path d="M14 9h7" />
                <path d="M14 15h7" />
                <path d="M14 20h7" />
              </svg>

)


const Inbox=({size=24, color = "currentColor", className = ""})=>(
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className= {`lucide lucide-layout-dashboard menu-icon ${className}`}
              >
                <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                <rect x="2" y="4" width="20" height="16" rx="2" />
              </svg>

)

const Database = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-database-icon lucide-database menu-icon"
  >
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5V19A9 3 0 0 0 21 19V5" />
    <path d="M3 12A9 3 0 0 0 21 12" />
  </svg>
);

const Rupees = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-indian-rupee-icon lucide-indian-rupee menu-icon"
  >
    <path d="M6 3h12" />
    <path d="M6 8h12" />
    <path d="m6 13 8.5 8" />
    <path d="M6 13h3" />
    <path d="M9 13c6.667 0 6.667-10 0-10" />
  </svg>
);

const Subscription = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
  >
    <desc>Created with Fabric.js 5.2.4</desc>
    <g transform="matrix(1 0 0 1 50 50)" id="a54c4b9f-6f3e-4624-a561-0d6e5f8b6aea">
      <rect
        x="-50"
        y="-50"
        rx="0"
        ry="0"
        width="100"
        height="100"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeDashoffset: 0,
          strokeLinejoin: "miter",
          strokeMiterlimit: 4,
          fill: "rgb(255,255,255)",
          fillRule: "nonzero",
          opacity: 1,
          visibility: "hidden"
        }}
        vectorEffect="non-scaling-stroke"
      />
    </g>

    <g transform="matrix(0.09 0 0 0.09 50 50)">
      <g vectorEffect="non-scaling-stroke">
        <g transform="matrix(1 0 0 1 2.3 -84.63)">
          <path
            d="M 433.885284 148.887115 C 456.696198 126.454109 483.909119 116.0411 515.414368 116.663445 C 560.251709 117.549141 593.325562 137.742859 613.841553 177.663406 C 622.626282 194.756882 625.02655 213.369873 624.387146 232.456802 ..."
            transform="translate(-512.8, -418.07)"
            style={{
              stroke: "none",
              strokeWidth: 1,
              strokeDasharray: "none",
              strokeLinecap: "butt",
              strokeDashoffset: 0,
              strokeLinejoin: "miter",
              strokeMiterlimit: 4,
              fill: "rgb(0,0,0)",
              fillRule: "nonzero",
              opacity: 1
            }}
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
          />
        </g>
        {/* Add the rest of your <g> / <path> elements here using the same format */}
      </g>
    </g>
  </svg>
);



const Shareicon = ({ size = 24, color = "currentColor", className = "" }) => (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={size}
                  height={size}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={color}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-share2-icon lucide-share-2 menu-icon"
                >
                  <circle cx="18" cy="5" r="3" />
                  <circle cx="6" cy="12" r="3" />
                  <circle cx="18" cy="19" r="3" />
                  <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                  <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                </svg>
);


// export default Subscription;


const SaveIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-save-icon lucide-save menu-icon"
  >
    <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" />
    <path d="M7 3v4a1 1 0 0 0 1 1h7" />
  </svg>
);

const RepostIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-repeat2-icon lucide-repeat-2 menu-icon"
  >
    <path d="m2 9 3-3 3 3" />
    <path d="M13 18H7a2 2 0 0 1-2-2V6" />
    <path d="m22 15-3 3-3-3" />
    <path d="M11 6h6a2 2 0 0 1 2 2v10" />
  </svg>
);
const DeletepostIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-delete-icon lucide-delete menu-icon"
  >
    <path d="M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z" />
    <path d="m12 9 6 6" />
    <path d="m18 9-6 6" />
  </svg>
);
const ClipboardpasteIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-clipboard-paste-icon lucide-clipboard-paste menu-icon"
  >
    <path d="M11 14h10" />
    <path d="M16 4h2a2 2 0 0 1 2 2v1.344" />
    <path d="m17 18 4-4-4-4" />
    <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 1.793-1.113" />
    <rect x="8" y="2" width="8" height="4" rx="1" />
  </svg>
);

const CheckedIcon1 = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="menu-icon"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
        stroke={color}
        strokeWidth="1.5"
      ></path>{" "}
      <path
        d="M8.5 12.5L10.5 14.5L15.5 9.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

const UnCheckedAllIcon = ({ size = 24, color = "currentColor", className = "" }) => (

  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="menu-icon"
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M20.4962,5.6267 
         C21.3721,5.9345 22,6.7689 22,7.75 
         V17.75 
         C22,20.0972 20.0972,22 17.75,22 
         H7.75 
         C6.7689,22 5.9345,21.3721 5.6267,20.4962 
         L7.724,20.4996 
         L17.75,20.5 
         C19.2688,20.5 20.5,19.2688 20.5,17.75 
         V7.75 
         L20.496,7.699 
         L20.4962,5.6267 
         Z

         M17.2468,2 
         C18.4895,2 19.4968,3.0074 19.4968,4.25 
         V17.2468 
         C19.4968,18.4895 18.4895,19.4968 17.2468,19.4968 
         H4.25 
         C3.0074,19.4968 2,18.4895 2,17.2468 
         V4.25 
         C2,3.0074 3.0074,2 4.25,2 
         H17.2468 
         Z

         M17.2468,3.5 
         H4.25 
         C3.8358,3.5 3.5,3.8358 3.5,4.25 
         V17.2468 
         C3.5,17.661 3.8358,17.9968 4.25,17.9968 
         H17.2468 
         C17.661,17.9968 17.9968,17.661 17.9968,17.2468 
         V4.25 
         C17.9968,3.8358 17.661,3.5 17.2468,3.5 
         Z"
    />
  </svg>
);


const CheckedAllIcon = ({ size = 24, color = "#212121", className = "" }) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="menu-icon"
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M20.4962,5.6267 
        C21.3721,5.9345 22,6.7689 22,7.75 
        V17.75 
        C22,20.0972 20.0972,22 17.75,22 
        H7.75 
        C6.7689,22 5.9345,21.3721 5.6267,20.4962 
        L7.724,20.4996 
        L17.75,20.5 
        C19.2688,20.5 20.5,19.2688 20.5,17.75 
        V7.75 
        L20.496,7.699 
        L20.4962,5.6267 
        Z

        M17.2468,2 
        C18.4895,2 19.4968,3.0074 19.4968,4.25 
        V17.2468 
        C19.4968,18.4895 18.4895,19.4968 17.2468,19.4968 
        H4.25 
        C3.0074,19.4968 2,18.4895 2,17.2468 
        V4.25 
        C2,3.0074 3.0074,2 4.25,2 
        H17.2468 
        Z

        M17.2468,3.5 
        H4.25 
        C3.8358,3.5 3.5,3.8358 3.5,4.25 
        V17.2468 
        C3.5,17.661 3.8358,17.9968 4.25,17.9968 
        H17.2468 
        C17.661,17.9968 17.9968,17.661 17.9968,17.2468 
        V4.25 
        C17.9968,3.8358 17.661,3.5 17.2468,3.5 
        Z

        M9.5811,11.3582 
        L13.4697,7.4697 
        C13.7626,7.1768 14.2374,7.1768 14.5303,7.4697 
        C14.7966,7.7359 14.8208,8.1526 14.6029,8.4462 
        L14.5303,8.5303 
        L10.0303,13.0303 
        C9.7345,13.3262 9.2613,13.3189 8.9736,13.0344 
        L8.9,12.95 
        L7.4,10.95 
        C7.1515,10.6186 7.2186,10.1485 7.55,9.9 
        C7.8512,9.6741 8.2671,9.709 8.527,9.9662 
        L8.6,10.05 
        L9.5811,11.3582 
        L13.4697,7.4697 
        L9.5811,11.3582 
        Z"
    />
  </svg>
);


const DeleteCheckedPosts = ({ size="24", color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 900 900"
    preserveAspectRatio="xMidYMid meet"
    fill={color}
    className="menu-icon"
  >
    <g transform="translate(0,900) scale(0.1,-0.1)" stroke="none">
      <path d="M1195 8403 c-176 -54 -298 -125 -406 -240 -108 -114 -164 -214 -213 -384 -14 -51 -16 -251 -16 -2164 0 -1913 2 -2113 16 -2164 25 -87 64 -181 97 -236 76 -127 222 -261 347 -321 141 -68 185 -76 425 -83 l220 -6 6 -175 c8 -242 34 -365 102 -492 18 -33 38 -71 46 -86 18 -35 198 -214 233 -233 15 -8 55 -29 90 -47 127 -67 248 -93 483 -101 l180 -6 6 -220 c7 -240 15 -284 83 -425 60 -125 194 -271 321 -347 55 -33 149 -72 236 -97 51 -14 251 -16 2164 -16 1913 0 2113 2 2164 16 210 61 357 158 474 314 75 99 111 175 151 311 14 51 16 251 16 2164 0 1913 -2 2113 -16 2164 -26 88 -64 182 -97 236 -62 102 -215 256 -287 288 -8 4 -30 16 -49 28 -18 11 -52 27 -75 35 -122 44 -140 47 -361 53 l-220 6 -6 175 c-8 242 -34 365 -102 492 -18 33 -38 71 -46 86 -8 15 -60 72 -115 127 -187 185 -344 243 -696 254 l-175 6 -6 220 c-6 219 -10 250 -52 355 -88 223 -270 401 -492 483 -136 50 12 47 -2266 46 -1860 -1 -2120 -3 -2164 -16z m4270 -567 c75 -49 127 -115 138 -176 7 -41 12 -338 5 -345 -2 -3 -720 -6 -1594 -8 -1247 -3 -1600 -6 -1639 -16 -27 -7 -77 -21 -110 -31 -52 -16 -85 -32 -213 -99 -36 -19 -219 -202 -232 -232 -6 -13 -26 -51 -45 -84 -32 -57 -56 -125 -86 -240 -10 -39 -13 -391 -16 -1642 -3 -1241 -6 -1592 -16 -1595 -7 -2 -91 -1 -187 2 -149 5 -180 9 -205 25 -47 29 -85 66 -114 110 l-26 40 0 2070 0 2070 26 40 c43 64 110 118 160 128 13 2 947 4 2074 3 2008 -1 2051 -1 2080 -20z m1106 -1120 c68 -31 122 -86 149 -154 18 -48 20 -71 18 -220 l-3 -167 -1630 -5 c-1483 -5 -1634 -7 -1680 -22 -136 -46 -189 -72 -285 -145 -78 -59 -190 -181 -213 -233 -4 -8 -16 -30 -28 -49 -20 -33 -35 -70 -67 -166 -15 -45 -17 -197 -22 -1680 l-5 -1630 -170 -3 c-154 -2 -174 -1 -220 19 -66 28 -121 82 -151 148 l-24 53 0 2028 0 2028 24 53 c28 64 83 119 146 147 45 20 60 20 2076 21 l2032 1 53 -24z m1144 -1130 c47 -31 85 -68 114 -111 l26 -40 0 -2070 c0 -2029 0 -2071 -19 -2100 -31 -47 -68 -85 -111 -114 l-40 -26 -2070 0 c-2029 0 -2071 0 -2100 19 -47 31 -85 68 -114 111 l-26 40 0 2070 0 2070 26 40 c43 64 110 118 160 128 13 2 947 4 2074 3 2008 -1 2051 -1 2080 -20z" />
      <path d="M4520 4622 c-61 -23 -140 -105 -163 -167 -25 -72 -22 -143 9 -209 21 -45 98 -126 435 -463 224 -224 409 -412 409 -418 0 -5 -185 -194 -410 -419 -336 -335 -413 -418 -434 -462 -50 -106 -28 -222 59 -309 87 -87 203 -109 309 -59 44 21 128 99 464 435 225 225 414 409 418 409 5 0 193 -185 417 -409 337 -337 418 -414 463 -435 106 -50 222 -28 309 59 87 87 109 203 59 309 -21 44 -99 128 -435 464 -225 225 -409 413 -409 417 0 4 184 192 409 417 336 336 414 420 435 464 50 106 28 222 -59 309 -87 87 -203 109 -309 59 -45 -21 -126 -98 -463 -435 -224 -224 -412 -409 -417 -409 -4 0 -193 184 -418 409 -453 453 -464 462 -576 460 -31 0 -77 -8 -102 -17z" />
    </g>
  </svg>
);

const OCRIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      d="M3 1a2 2 0 0 0-2 2v4.5h2V3h5V1H3zM1 17v-5.5h2V17h5v2H3a2 2 0 0 1-2-2zm11 0v2h5a2 2 0 0 0 2-2v-5.5h-2V17h-5zm5-9.5h2V3a2 2 0 0 0-2-2h-5v2h5v4.5z"
    />
    <path fill={color} d="M6 5h8v1H6zM5 8h10v1H5zm1 3h8v1H6zm-1 3h10v1H5z" />
  </svg>
);

const MenuIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.88 103.17"
    width={size}
    height={size}
    fill={color}
    className={className}
  >
    <path d="M26,0h70.87c7.15,0,13.65,2.93,18.36,7.64l0.22,0.24c4.58,4.69,7.42,11.1,7.42,18.13v51.16c0,7.15-2.93,13.65-7.64,18.36 
      c-4.71,4.71-11.21,7.64-18.36,7.64H26c-7.14,0-13.64-2.93-18.35-7.64H7.64C2.93,90.82,0,84.32,0,77.16V26 
      c0-7.13,2.92-13.63,7.64-18.35l0.02-0.03C12.38,2.92,18.87,0,26,0L26,0z M41.31,29.74h40.26c2.25,0,4.09,1.84,4.09,4.09 
      s-1.84,4.09-4.09,4.09H41.31c-2.25,0-4.09-1.84-4.09-4.09S39.06,29.74,41.31,29.74z M41.31,65.25h40.26c2.25,0,4.09,1.84,4.09,4.09 
      s-1.84,4.09-4.09,4.09H41.31c-2.25,0-4.09-1.84-4.09-4.09S39.06,65.25,41.31,65.25z M41.31,47.5h40.26c2.25,0,4.09,1.84,4.09,4.09 
      s-1.84,4.09-4.09,4.09H41.31c-2.25,0-4.09-1.84-4.09-4.09S39.06,47.5,41.31,47.5z M96.88,8.2H26c-4.9,0-9.35,2-12.57,5.22 
      C10.2,16.65,8.2,21.1,8.2,26v51.16c0,4.89,2.01,9.34,5.23,12.56c3.23,3.22,7.68,5.23,12.57,5.23h70.87c4.88,0,9.33-2.01,12.56-5.24 
      c3.23-3.23,5.24-7.68,5.24-12.56V26c0-4.8-1.93-9.17-5.04-12.39C106.21,10.21,101.77,8.2,96.88,8.2z" />
  </svg>
);

// const CancelIcon = ({ size = 24, color = "currentColor" }) => (
//   <svg
//     fill={color}
//     width={size}
//     height={size}
//     viewBox="0 0 30 30"
//     xmlns="http://www.w3.org/2000/svg"
//     aria-label="Cancel icon"
//     role="img"
//     className="menu-icon"
//   >
//     <title>Cancel</title>
//     <path d="M16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM16 6c-5.522 0-10 4.478-10 10s4.478 10 10 10c5.523 0 10-4.478 10-10s-4.477-10-10-10zM20.537 19.535l-1.014 1.014c-0.186 0.186-0.488 0.186-0.675 0l-2.87-2.87-2.87 2.87c-0.187 0.186-0.488 0.186-0.675 0l-1.014-1.014c-0.186-0.186-0.186-0.488 0-0.675l2.871-2.869-2.871-2.87c-0.186-0.187-0.186-0.489 0-0.676l1.014-1.013c0.187-0.187 0.488-0.187 0.675 0l2.87 2.87 2.87-2.87c0.187-0.187 0.489-0.187 0.675 0l1.014 1.013c0.186 0.187 0.186 0.489 0 0.676l-2.871 2.87 2.871 2.869c0.186 0.187 0.186 0.49 0 0.675z" />
//   </svg>
// );





// const CancelIcon = ({ size = 24, color = '#000000' }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={size}
//     height={size}
//     viewBox="0 0 256 256"
//     fill={color}
//     role="img"
//     aria-label="Cancel icon"
//     className="menu-icon"
//   >
//     <g transform="translate(13.6467 13.6467) scale(2.53 2.53)">
//       <path
//         d="M 28.5 65.5 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 l 33 -33 c 1.561 -1.562 4.096 -1.562 5.656 0 c 1.563 1.563 1.563 4.095 0 5.657 l -33 33 C 30.547 65.109 29.524 65.5 28.5 65.5 z"
//         fill={color}
//       />
//       <path
//         d="M 61.5 65.5 c -1.023 0 -2.048 -0.391 -2.828 -1.172 l -33 -33 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 l 33 33 c 1.563 1.562 1.563 4.095 0 5.656 C 63.548 65.109 62.523 65.5 61.5 65.5 z"
//         fill={color}
//       />
//       <path
//         d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 8 C 24.598 8 8 24.598 8 45 c 0 20.402 16.598 37 37 37 c 20.402 0 37 -16.598 37 -37 C 82 24.598 65.402 8 45 8 z"
//         fill={color}
//       />
//     </g>
//   </svg>
// );

const CancelIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    fill={color}
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.87 122.87"
    className="menu-icon"
  >
    <title>remove</title>
    <path d="M18,18A61.45,61.45,0,1,1,0,61.44,61.28,61.28,0,0,1,18,18ZM77.38,39l6.53,6.54a4,4,0,0,1,0,5.63L73.6,61.44,83.91,71.75a4,4,0,0,1,0,5.63l-6.53,6.53a4,4,0,0,1-5.63,0L61.44,73.6,51.13,83.91a4,4,0,0,1-5.63,0L39,77.38a4,4,0,0,1,0-5.63L49.28,61.44,39,51.13a4,4,0,0,1,0-5.63L45.5,39a4,4,0,0,1,5.63,0L61.44,49.28,71.75,39a4,4,0,0,1,5.63,0ZM61.44,10.54a50.91,50.91,0,1,0,36,14.91,50.83,50.83,0,0,0-36-14.91Z" />
  </svg>
)


const whatsappIcon = ({ size = 24, color = "#000000"})=>(
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill={color}
  >
    <g id="SVGRepo_bgCarrier" 
        strokeWidth="0"      
    ></g>
    <g
      id="SVGRepo_tracerCarrier"
      // stroke-linecap="round"
      // stroke-linejoin="round"

        strokeLinecap="round"
        strokeLinejoin="round"


></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <title>Whatsapp-color</title> <desc>Created with Sketch.</desc>{" "}
      <defs> </defs>{" "}
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1.5"
      

        fill="none"
        fill-rule="evenodd"
      >
        {" "}
        <g
          id="Color-"
          transform="translate(-700.000000, -360.000000)"
          fill="#67C15E"
        >
          {" "}
          <path
            d="M723.993033,360 C710.762252,360 700,370.765287 700,383.999801 C700,389.248451 701.692661,394.116025 704.570026,398.066947 L701.579605,406.983798 L710.804449,404.035539 C714.598605,406.546975 719.126434,408 724.006967,408 C737.237748,408 748,397.234315 748,384.000199 C748,370.765685 737.237748,360.000398 724.006967,360.000398 L723.993033,360.000398 L723.993033,360 Z M717.29285,372.190836 C716.827488,371.07628 716.474784,371.034071 715.769774,371.005401 C715.529728,370.991464 715.262214,370.977527 714.96564,370.977527 C714.04845,370.977527 713.089462,371.245514 712.511043,371.838033 C711.806033,372.557577 710.056843,374.23638 710.056843,377.679202 C710.056843,381.122023 712.567571,384.451756 712.905944,384.917648 C713.258648,385.382743 717.800808,392.55031 724.853297,395.471492 C730.368379,397.757149 732.00491,397.545307 733.260074,397.27732 C735.093658,396.882308 737.393002,395.527239 737.971421,393.891043 C738.54984,392.25405 738.54984,390.857171 738.380255,390.560912 C738.211068,390.264652 737.745308,390.095816 737.040298,389.742615 C736.335288,389.389811 732.90737,387.696673 732.25849,387.470894 C731.623543,387.231179 731.017259,387.315995 730.537963,387.99333 C729.860819,388.938653 729.198006,389.89831 728.661785,390.476494 C728.238619,390.928051 727.547144,390.984595 726.969123,390.744481 C726.193254,390.420348 724.021298,389.657798 721.340985,387.273388 C719.267356,385.42535 717.856938,383.125756 717.448104,382.434484 C717.038871,381.729275 717.405907,381.319529 717.729948,380.938852 C718.082653,380.501232 718.421026,380.191036 718.77373,379.781688 C719.126434,379.372738 719.323884,379.160897 719.549599,378.681068 C719.789645,378.215575 719.62006,377.735746 719.450874,377.382942 C719.281687,377.030139 717.871269,373.587317 717.29285,372.190836 Z"
            id="Whatsapp"
          >
            {" "}
          </path>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
);

const CompanyIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-landmark-icon lucide-landmark menu-icon"
  >
    <path d="M10 18v-7" />
    <path d="M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z" />
    <path d="M14 18v-7" />
    <path d="M18 18v-7" />
    <path d="M3 22h18" />
    <path d="M6 18v-7" />
  </svg>
);

const AddressIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-notebook-tabs-icon lucide-notebook-tabs menu-icon"
  >
    <path d="M2 6h4" />
    <path d="M2 10h4" />
    <path d="M2 14h4" />
    <path d="M2 18h4" />
    <rect width="16" height="20" x="4" y="2" rx="2" />
    <path d="M15 2v20" />
    <path d="M15 7h5" />
    <path d="M15 12h5" />
    <path d="M15 17h5" />
  </svg>
);

const UserNameIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-circle-user-round-icon lucide-circle-user-round menu-icon"
  >
    <path d="M18 20a6 6 0 0 0-12 0" />
    <circle cx="12" cy="10" r="4" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);                        


// i used picsart and picxelied for removing background and converting to svg onlie

const ClientTypeIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
      <path
        d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
      <path
        d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
      <path
        d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);


const ColonyInterestIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-locate-icon lucide-locate menu-icon"
  >
    <line x1="2" x2="5" y1="12" y2="12" />
    <line x1="19" x2="22" y1="12" y2="12" />
    <line x1="12" x2="12" y1="2" y2="5" />
    <line x1="12" x2="12" y1="19" y2="22" />
    <circle cx="12" cy="12" r="7" />
  </svg>
);

// const ColonyInterestIcon = ({ size = 24, color = "#000000" }) => (



const WhatsappIcon = ({ size = 24, color = "#13d029ff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 510 512.459"
    fill={color}
  >
    <path d="M435.689 74.468C387.754 26.471 324 .025 256.071 0 116.098 0 2.18 113.906 2.131 253.916c-.024 44.758 11.677 88.445 33.898 126.946L0 512.459l134.617-35.311c37.087 20.238 78.85 30.891 121.345 30.903h.109c139.949 0 253.88-113.917 253.928-253.928.024-67.855-26.361-131.645-74.31-179.643v-.012zm-179.618 390.7h-.085c-37.868-.011-75.016-10.192-107.428-29.417l-7.707-4.577-79.886 20.953 21.32-77.889-5.017-7.987c-21.125-33.605-32.29-72.447-32.266-112.322.049-116.366 94.729-211.046 211.155-211.046 56.373.025 109.364 22.003 149.214 61.903 39.853 39.888 61.781 92.927 61.757 149.313-.05 116.377-94.728 211.058-211.057 211.058v.011zm115.768-158.067c-6.344-3.178-37.537-18.52-43.358-20.639-5.82-2.119-10.044-3.177-14.27 3.178-4.225 6.357-16.388 20.651-20.09 24.875-3.702 4.238-7.403 4.762-13.747 1.583-6.343-3.178-26.787-9.874-51.029-31.487-18.86-16.827-31.597-37.598-35.297-43.955-3.702-6.355-.39-9.789 2.775-12.943 2.849-2.848 6.344-7.414 9.522-11.116s4.225-6.355 6.343-10.581c2.12-4.238 1.06-7.937-.522-11.117-1.584-3.177-14.271-34.409-19.568-47.108-5.151-12.37-10.385-10.69-14.269-10.897-3.703-.183-7.927-.219-12.164-.219s-11.105 1.582-16.925 7.939c-5.82 6.354-22.209 21.709-22.209 52.927 0 31.22 22.733 61.405 25.911 65.642 3.177 4.237 44.745 68.318 108.389 95.812 15.135 6.538 26.957 10.446 36.175 13.368 15.196 4.834 29.027 4.153 39.96 2.52 12.19-1.825 37.54-15.353 42.824-30.172 5.283-14.818 5.283-27.529 3.701-30.172-1.582-2.641-5.819-4.237-12.163-7.414l.011-.024z" />
  </svg>
);


const PhoneIcon=({ size = 24, color = "#000000" })=>(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-phone-call menu-icon"
      >
        <path d="M13 2a9 9 0 0 1 9 9" />
        <path d="M13 6a5 5 0 0 1 5 5" />
        <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
      </svg>
      )
const EmailIcon=({ size = 24, color = "#000000" })=>(    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-mail menu-icon"
    >
      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
      <rect x="2" y="4" width="20" height="16" rx="2" />
    </svg>
    )

const ChatIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-message-square-text-icon lucide-message-square-text menu-icon"
  >
    <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
    <path d="M7 11h10" />
    <path d="M7 15h6" />
    <path d="M7 7h8" />
  </svg>
);

const BookmarkIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-bookmark-icon lucide-bookmark menu-icon"
  >
    <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
  </svg>
);

const MapPinIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-map-pin-icon lucide-map-pin menu-icon"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

// const BhoomiLogoIcon = ({ size = 24, color = "#000000" }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     version="1.0"
//     width={size}
//     height={size}
//     viewBox="0 0 100.000000 100.000000"
//     preserveAspectRatio="xMidYMid meet"
//   >
//     <metadata>
//       Created by potrace 1.10, written by Peter Selinger 2001-2011
//     </metadata>
//     <g
//       transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
//       fill={color}
//       stroke="none"
//     >
//       <path d="M232 954 c-18 -9 -43 -31 -55 -48 -22 -30 -22 -37 -25 -401 -2 -355 -2 -371 18 -403 11 -18 34 -41 52 -52 31 -19 47 -21 253 -18 206 3 223 4 262 25 135 73 178 218 106 360 -36 73 -182 227 -244 259 -60 30 -100 30 -164 0 -58 -27 -78 -47 -100 -99 -63 -152 76 -310 235 -267 46 12 120 75 120 102 0 8 -16 29 -35 48 -28 27 -35 30 -35 16 0 -31 -64 -86 -100 -86 -63 0 -110 47 -110 110 0 91 95 141 166 88 62 -47 182 -187 199 -232 32 -82 10 -159 -59 -210 -25 -19 -44 -21 -237 -24 -151 -2 -215 0 -225 9 -12 9 -14 72 -14 365 0 307 2 355 16 368 13 13 42 16 159 16 79 0 156 -5 172 -11 70 -26 129 -117 121 -188 -2 -19 8 -40 30 -66 17 -21 34 -36 37 -33 3 3 11 32 17 64 21 114 -36 228 -142 288 -55 31 -56 31 -220 34 -138 2 -170 0 -198 -14z" />
//     </g>
//   </svg>
// );


// in and out
// const BhoomiLogoIcon = ({ size = 120, color = "#000000" }) => (
//   <>
//     <style>
//       {`
//         .bhoomi-logo-pulse {
//           animation: pulse 2s infinite ease-in-out;
//         }

//         @keyframes pulse {
//           0% { transform: scale(1); opacity: 1; }
//           50% { transform: scale(1.08); opacity: 0.75; }
//           100% { transform: scale(1); opacity: 1; }
//         }
//       `}
//     </style>

//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={size}
//       height={size}
//       viewBox="0 0 100 100"
//       className="bhoomi-logo-pulse"
//       preserveAspectRatio="xMidYMid meet"
//     >
//       <g
//         transform="translate(0,100) scale(0.1,-0.1)"
//         fill={color}
//         stroke="none"
//       >
//         <path d="M232 954 c-18 -9 -43 -31 -55 -48 -22 -30 -22 -37 -25 -401 -2 -355 -2 -371 18 -403 11 -18 34 -41 52 -52 31 -19 47 -21 253 -18 206 3 223 4 262 25 135 73 178 218 106 360 -36 73 -182 227 -244 259 -60 30 -100 30 -164 0 -58 -27 -78 -47 -100 -99 -63 -152 76 -310 235 -267 46 12 120 75 120 102 0 8 -16 29 -35 48 -28 27 -35 30 -35 16 0 -31 -64 -86 -100 -86 -63 0 -110 47 -110 110 0 91 95 141 166 88 62 -47 182 -187 199 -232 32 -82 10 -159 -59 -210 -25 -19 -44 -21 -237 -24 -151 -2 -215 0 -225 9 -12 9 -14 72 -14 365 0 307 2 355 16 368 13 13 42 16 159 16 79 0 156 -5 172 -11 70 -26 129 -117 121 -188 -2 -19 8 -40 30 -66 17 -21 34 -36 37 -33 3 3 11 32 17 64 21 114 -36 228 -142 288 -55 31 -56 31 -220 34 -138 2 -170 0 -198 -14z"/>
//       </g>
//     </svg>
//   </>
// );


// draw animation
// const BhoomiLogoIcon = ({ size = 150, color = "#000000", duration = 3 }) => (
//   <>
//     <style>
//       {`
//         .bhoomi-logo-draw path {
//           stroke-dasharray: 2000;
//           stroke-dashoffset: 2000;
//           animation: bhoomiDraw ${duration}s ease forwards;
//         }

//         @keyframes bhoomiDraw {
//           to {
//             stroke-dashoffset: 0;
//           }
//         }
//       `}
//     </style>

//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={size}
//       height={size}
//       viewBox="0 0 100 100"
//       className="bhoomi-logo-draw"
//       preserveAspectRatio="xMidYMid meet"
//     >
//       <g
//         transform="translate(0,100) scale(0.1,-0.1)"
//         fill="none"
//         stroke={color}
//         strokeWidth="20"
//       >
//         <path d="M232 954 c-18 -9 -43 -31 -55 -48 -22 -30 -22 -37 -25 -401 -2 -355 -2 -371 18 -403 11 -18 34 -41 52 -52 31 -19 47 -21 253 -18 206 3 223 4 262 25 135 73 178 218 106 360 -36 73 -182 227 -244 259 -60 30 -100 30 -164 0 -58 -27 -78 -47 -100 -99 -63 -152 76 -310 235 -267 46 12 120 75 120 102 0 8 -16 29 -35 48 -28 27 -35 30 -35 16 0 -31 -64 -86 -100 -86 -63 0 -110 47 -110 110 0 91 95 141 166 88 62 -47 182 -187 199 -232 32 -82 10 -159 -59 -210 -25 -19 -44 -21 -237 -24 -151 -2 -215 0 -225 9 -12 9 -14 72 -14 365 0 307 2 355 16 368 13 13 42 16 159 16 79 0 156 -5 172 -11 70 -26 129 -117 121 -188 -2 -19 8 -40 30 -66 17 -21 34 -36 37 -33 3 3 11 32 17 64 21 114 -36 228 -142 288 -55 31 -56 31 -220 34 -138 2 -170 0 -198 -14z" />
//       </g>
//     </svg>
//   </>
// );


// draw and fill animation
// const BhoomiLogoIcon = ({ size = 150, color = "#000", duration = 3 }) => (
//   <>
//     <style>
//       {`
//         .bhoomi-path {
//           stroke-dasharray: 2000;
//           stroke-dashoffset: 2000;
//           stroke: ${color};
//           stroke-width: 20;
//           fill: transparent;
//           animation:
//             bhoomiDraw ${duration}s ease forwards,
//             bhoomiFill 0.8s ease forwards ${duration}s; /* fill AFTER draw */
//         }

//         @keyframes bhoomiDraw {
//           from { stroke-dashoffset: 2000; }
//           to   { stroke-dashoffset: 0; }
//         }

//         @keyframes bhoomiFill {
//           from { fill: transparent; }
//           to   { fill: ${color}; }
//         }
//       `}
//     </style>

//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={size}
//       height={size}
//       viewBox="0 0 100 100"
//       preserveAspectRatio="xMidYMid meet"
//     >
//       <g
//         transform="translate(0,100) scale(0.1,-0.1)"
//       >
//         <path
//           className="bhoomi-path"
//           d="M232 954 c-18 -9 -43 -31 -55 -48 -22 -30 -22 -37 -25 -401 -2 -355 -2 -371 18 -403 11 -18 34 -41 52 -52 31 -19 47 -21 253 -18 206 3 223 4 262 25 135 73 178 218 106 360 -36 73 -182 227 -244 259 -60 30 -100 30 -164 0 -58 -27 -78 -47 -100 -99 -63 -152 76 -310 235 -267 46 12 120 75 120 102 0 8 -16 29 -35 48 -28 27 -35 30 -35 16 0 -31 -64 -86 -100 -86 -63 0 -110 47 -110 110 0 91 95 141 166 88 62 -47 182 -187 199 -232 32 -82 10 -159 -59 -210 -25 -19 -44 -21 -237 -24 -151 -2 -215 0 -225 9 -12 9 -14 72 -14 365 0 307 2 355 16 368 13 13 42 16 159 16 79 0 156 -5 172 -11 70 -26 129 -117 121 -188 -2 -19 8 -40 30 -66 17 -21 34 -36 37 -33 3 3 11 32 17 64 21 114 -36 228 -142 288 -55 31 -56 31 -220 34 -138 2 -170 0 -198 -14z"
//         />
//       </g>
//     </svg>
//   </>
// );


const BhoomiLogoIcon = ({ size = 150, color = "#767575ff", duration = 3 }) => {
  const totalDuration = duration + 0.8 + 3; // draw + fill + pause

  return (
    <>
      <style>
        {`
          .bhoomi-loop {
            animation: bhoomiFullLoop ${totalDuration}s ease-in-out infinite;
          }

          @keyframes bhoomiFullLoop {
            0% {
              stroke-dasharray: 2000;
              stroke-dashoffset: 2000; /* completely hidden */
              fill: transparent;
            }

            /* Draw animation */
            ${(duration / totalDuration) * 100}% {
              stroke-dashoffset: 0; /* fully drawn */
              fill: transparent;
            }

            /* Fill animation right after draw */
            ${((duration + 0.8) / totalDuration) * 100}% {
              stroke-dashoffset: 0;
              fill: ${color};
            }

            /* Wait 3 seconds with the full logo visible */
            90% {
              stroke-dashoffset: 0;
              fill: ${color};
            }

            /* Reset to start drawing again */
            100% {
              stroke-dashoffset: 2000;
              fill: transparent;
            }
          }
        `}
      </style>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
      >
        <g transform="translate(0,100) scale(0.1,-0.1)" stroke={color} strokeWidth="50">
          <path
            className="bhoomi-loop"
            fill="transparent"
            d="M232 954 c-18 -9 -43 -31 -55 -48 -22 -30 -22 -37 -25 -401 -2 -355 -2 -371 18 -403 11 -18 34 -41 52 -52 31 -19 47 -21 253 -18 206 3 223 4 262 25 135 73 178 218 106 360 -36 73 -182 227 -244 259 -60 30 -100 30 -164 0 -58 -27 -78 -47 -100 -99 -63 -152 76 -310 235 -267 46 12 120 75 120 102 0 8 -16 29 -35 48 -28 27 -35 30 -35 16 0 -31 -64 -86 -100 -86 -63 0 -110 47 -110 110 0 91 95 141 166 88 62 -47 182 -187 199 -232 32 -82 10 -159 -59 -210 -25 -19 -44 -21 -237 -24 -151 -2 -215 0 -225 9 -12 9 -14 72 -14 365 0 307 2 355 16 368 13 13 42 16 159 16 79 0 156 -5 172 -11 70 -26 129 -117 121 -188 -2 -19 8 -40 30 -66 17 -21 34 -36 37 -33 3 3 11 32 17 64 21 114 -36 228 -142 288 -55 31 -56 31 -220 34 -138 2 -170 0 -198 -14z"
          />
        </g>
      </svg>
    </>
  );
};








const CircleSpinnerIcon = ({
  size = 80,
  strokeWidth = 6,
  color = "#767575ff",
  duration = 2  // draw duration
}) => {
  const fillDuration = 0.5; 
  const holdDuration = 0.8; 
  const total = duration + fillDuration + holdDuration;

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const drawPercent = (duration / total) * 100;
  const fillPercent = ((duration + fillDuration) / total) * 100;

  return (
    <>
      <style>
        {`
          .circle-spin-animation {
            animation: circleSpinLoop ${total}s ease-in-out infinite;
            transform-origin: center;
          }

          @keyframes circleSpinLoop {
            0% {
              stroke-dasharray: ${circumference};
              stroke-dashoffset: ${circumference};
              fill: transparent;
              transform: rotate(0deg);
            }

            /* Draw */
            ${drawPercent}% {
              stroke-dashoffset: 0;
              fill: transparent;
              transform: rotate(90deg);
            }

            /* Fill */
            ${fillPercent}% {
              stroke-dashoffset: 0;
              fill: ${color};
              transform: rotate(180deg);
            }

            /* Hold full circle */
            90% {
              stroke-dashoffset: 0;
              fill: ${color};
              transform: rotate(270deg);
            }

            /* Reset */
            100% {
              stroke-dashoffset: ${circumference};
              fill: transparent;
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        <circle
          className="circle-spin-animation"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};


const DualRingSpinner = ({
  size = 80,
  strokeWidth = 6,
  color = "#767575ff",
  duration = 1.4
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <>
      <style>{`
        @keyframes dualRingRotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes dualRingPulse {
          0%, 100% { stroke-dashoffset: 0; }
          50% { stroke-dashoffset: ${circumference / 2}; }
        }

        .dual-ring {
          transform-origin: center;
          animation:
            dualRingRotate ${duration}s linear infinite,
            dualRingPulse ${duration}s ease-in-out infinite;
        }
      `}</style>

      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="dual-ring"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};


const DotOrbitSpinner = ({
  size = 80,
  color = "#767575ff",
  duration = 1.5
}) => {
  return (
    <>
      <style>{`
        @keyframes orbit {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .orbit {
          transform-origin: center;
          animation: orbit ${duration}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        <g className="orbit">
          <circle
            cx={size / 2}
            cy={size / 2 - size * 0.35}
            r={size * 0.08}
            fill={color}
          />
        </g>
      </svg>
    </>
  );
};

const TrailArcSpinner = ({
  size = 80,
  strokeWidth = 6,
  color = "#767575ff",
  duration = 1.6
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <>
      <style>{`
        @keyframes arcSpin {
          0%   { stroke-dasharray: 1, ${circumference}; stroke-dashoffset: 0; }
          50%  { stroke-dasharray: ${circumference / 2}, ${circumference}; stroke-dashoffset: -${circumference / 4}; }
          100% { stroke-dasharray: 1, ${circumference}; stroke-dashoffset: -${circumference}; }
        }

        .arc-spin {
          transform-origin: center;
          animation: arcSpin ${duration}s ease-in-out infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        <circle
          className="arc-spin"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};


const ThreeDotsBounceSpinner = ({
  size = 20,
  color = "#767575ff",
  duration = 0.6
}) => {
  return (
    <>
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(1); }
          40% { transform: scale(1.5); }
        }

        .bounce {
          animation: bounce ${duration}s infinite ease-in-out;
        }
      `}</style>

      <svg width={size * 4} height={size}>
        {[0,1,2].map((i) => (
          <circle
            key={i}
            cx={size * (i + 1)}
            cy={size / 2}
            r={size / 4}
            fill={color}
            className="bounce"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </svg>
    </>
  );
};


const BarWaveSpinner = ({
  size = 50,
  color = "#767575ff",
  duration = 0.8
}) => {
  const barWidth = size / 8;

  return (
    <>
      <style>{`
        @keyframes wave {
          0%, 100% { height: 20%; }
          50% { height: 80%; }
        }
      `}</style>

      <svg width={size} height={size}>
        {[0,1,2,3,4].map((i) => (
          <rect
            key={i}
            x={i * (barWidth * 1.4)}
            y={size * 0.1}
            width={barWidth}
            height={size * 0.2}
            fill={color}
            style={{
              animation: `wave ${duration}s ease-in-out infinite`,
              animationDelay: `${i * 0.1}s`
            }}
            rx={barWidth / 2}
          />
        ))}
      </svg>
    </>
  );
};

const BlobMorphSpinner = ({
  size = 80,
  color = "#767575ff",
  duration = 3
}) => (
  <>
    <style>{`
      @keyframes blobMorph {
        0% { d: path("M40 10 Q60 20 70 40 Q60 60 40 70 Q20 60 10 40 Q20 20 40 10"); }
        50% { d: path("M40 5 Q65 25 75 40 Q65 65 40 75 Q15 65 5 40 Q15 25 40 5"); }
        100% { d: path("M40 10 Q60 20 70 40 Q60 60 40 70 Q20 60 10 40 Q20 20 40 10"); }
      }
      .blob {
        animation: blobMorph ${duration}s ease-in-out infinite;
      }
    `}</style>

    <svg width={size} height={size} viewBox="0 0 80 80">
      <path
        className="blob"
        fill={color}
        d="M40 10 Q60 20 70 40 Q60 60 40 70 Q20 60 10 40 Q20 20 40 10"
      />
    </svg>
  </>
);

const SingleOrbitSpinner = ({
  size = 100,
  color = "#767575ff",
  duration = 2
}) => {
  const bigR = size * 0.4;   // radius of orbit path
  const smallR = size * 0.07;

  return (
    <>
      <style>{`
        @keyframes orbitSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .orbit-container {
          transform-origin: center;
          animation: orbitSpin ${duration}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        {/* Big circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={bigR}
          stroke={color}
          strokeWidth={2}
          fill="none"
          opacity={0.4}
        />

        {/* Rotating group */}
        <g className="orbit-container">
          <circle
            cx={size / 2}
            cy={size / 2 - bigR}
            r={smallR}
            fill={color}
          />
        </g>
      </svg>
    </>
  );
};


const MultiOrbitSpinner = ({
  size = 120,
  color = "#767575ff",
  count = 4,
  duration = 2.5
}) => {
  const bigR = size * 0.42;
  const smallR = size * 0.07;

  return (
    <>
      <style>{`
        @keyframes multiOrbitSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .multi-orbit {
          transform-origin: center;
          animation: multiOrbitSpin ${duration}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        {/* orbit path */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={bigR}
          stroke={color}
          strokeWidth={2}
          fill="none"
          opacity={0.35}
        />

        {/* rotating group */}
        <g className="multi-orbit">
          {[...Array(count)].map((_, i) => {
            const angle = (i / count) * 2 * Math.PI;
            const x = size / 2 + bigR * Math.sin(angle);
            const y = size / 2 - bigR * Math.cos(angle);

            return (
              <circle key={i} cx={x} cy={y} r={smallR} fill={color} />
            );
          })}
        </g>
      </svg>
    </>
  );
};


const MultiOrbitSpinner2 = ({
  size = 120,
  color = "#767575ff",
  duration = 2.5,
  count = 5
}) => {
  const bigR = size * 0.42;

  // size of the largest and smallest circle
  const maxR = size * 0.09;
  const minR = size * 0.03;

  return (
    <>
      <style>{`
        @keyframes multiOrbitSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .multi-orbit {
          transform-origin: center;
          animation: multiOrbitSpin ${duration}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        {/* hidden orbit path (removed stroke) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={bigR}
          fill="none"
          stroke="transparent"
        />

        {/* rotating group */}
        <g className="multi-orbit">
          {[...Array(count)].map((_, i) => {
            const angle = (i / count) * 2 * Math.PI;

            // size transition: largest → smallest
            const r = maxR - (i / (count - 1)) * (maxR - minR);

            const x = size / 2 + bigR * Math.sin(angle);
            const y = size / 2 - bigR * Math.cos(angle);

            return (
              <circle
                key={i}
                cx={x}
                cy={y}
                r={r}
                fill={color}
              />
            );
          })}
        </g>
      </svg>
    </>
  );
};

const MultiOrbitSpinner3 = ({
  size = 120,
  color = "#767575ff",
  duration = 2.5,
  count = 5
}) => {
  // const bigR = size * 0.42;
  const bigR = size * 0.30;


  // Increased sizes — much bigger circles now
  const maxR = size * 0.10; // was 0.09
  const minR = size * 0.07; // was 0.03

  return (
    <>
      <style>{`
        @keyframes multiOrbitSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .multi-orbit {
          transform-origin: center;
          animation: multiOrbitSpin ${duration}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        {/* hidden orbit line */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={bigR}
          fill="none"
          stroke="transparent"
        />

        <g className="multi-orbit">
          {[...Array(count)].map((_, i) => {
            const angle = (i / count) * 2 * Math.PI;

            // Larger circle size gradient
            const r = maxR - (i / (count - 1)) * (maxR - minR);

            const x = size / 2 + bigR * Math.sin(angle);
            const y = size / 2 - bigR * Math.cos(angle);

            return (
              <circle
                key={i}
                cx={x}
                cy={y}
                r={r}
                fill={color}
              />
            );
          })}
        </g>
      </svg>
    </>
  );
};


const DualRotationOrbitSpinner = ({
  size = 120,
  color = "#767575ff",
  duration = 2
}) => {
  const bigR = size * 0.42;
  const smallR = size * 0.07;

  return (
    <>
      <style>{`
        @keyframes outerRotation {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes innerRotation {
          0% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }

        .outer {
          transform-origin: center;
          animation: outerRotation ${duration}s linear infinite;
        }

        .inner {
          transform-origin: center;
          animation: innerRotation ${duration * 0.6}s linear infinite;
        }
      `}</style>

      <svg width={size} height={size}>
        {/* Outer rotation group */}
        <g className="outer">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={bigR}
            stroke={color}
            strokeWidth={2}
            fill="none"
            opacity={0.35}
          />

          {/* Inner rotation counter-motion */}
          <g className="inner">
            <circle
              cx={size / 2}
              cy={size / 2 - bigR}
              r={smallR}
              fill={color}
            />
          </g>
        </g>
      </svg>
    </>
  );
};





const ClientsIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 74.52) / 122.88} // maintain aspect ratio
    viewBox="0 0 122.88 74.52"
    fill={color}
    className="menu-icon clients-icon"
  >
    <path
      fillRule="evenodd"
      d="M29.18,44.74c.23-1.88-5.33-9-6.35-12.47-2.18-3.46-2.95-9-.57-12.62.94-1.45.53-2.71.53-4.72,0-19.9,34.88-19.91,34.88,0,0,2.52-.57,3.11.79,5.1,2.28,3.3,1.11,9.18-.82,12.25C56.4,35.89,50.57,42.7,51,44.75c.37,10.21-21.85,9.87-21.79,0ZM41.9,62.41h1.22a2,2,0,0,0,2-2V57.15a2,2,0,0,0-2-2H35.86a2,2,0,0,0-2,2V60.4a2,2,0,0,0,2,2H37.1L34.72,74.52h9.47L41.9,62.41ZM0,74.52C.94,62.3-1.45,62.83,8.77,59A78.79,78.79,0,0,0,23.1,51.74l8.78,22.78ZM56.26,50.7A58,58,0,0,0,69.5,57.32C79.05,60.5,79,60.94,79,74.52H47.2L56.26,50.7ZM91.49,64.78h1a1.62,1.62,0,0,0,1.62-1.61V60.56a1.63,1.63,0,0,0-1.62-1.62H86.63A1.62,1.62,0,0,0,85,60.56v2.61a1.62,1.62,0,0,0,1.61,1.61h1l-1.91,9.74h7.61l-1.84-9.74ZM81.27,50.58c.18-1.51-4.29-7.26-5.11-10-1.75-2.78-2.37-7.21-.46-10.14.76-1.17.43-2.18.43-3.8,0-16,28-16,28,0,0,2-.46,2.5.63,4.1,1.83,2.66.89,7.38-.66,9.85-1,2.9-5.68,8.37-5.36,10,.3,8.21-17.56,7.94-17.51,0ZM103,55.38a59,59,0,0,0,12.24,5.31c7.68,2.56,7.65,2.91,7.6,13.83H95.75L103,55.38Z"
    />
  </svg>
);

// dealicon
{/* <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 501.76"><path d="M363.49 208.04 439.55 76.3 305.09 0 172.57 229.53c9.52-3.86 19.55-6.42 29.79-7.47l97.06-168.12c12.56 7.15 26.54 3.27 32.77-7.69l52.93 30.56c-6.03 10.61-2.15 24.6 8.77 30.79l-51.68 89.51c7.41 2.99 14.48 6.74 21.28 10.93zM65.73 381.06c6.11 0 11.07 4.96 11.07 11.07 0 6.12-4.96 11.07-11.07 11.07s-11.07-4.95-11.07-11.07c0-6.11 4.96-11.07 11.07-11.07zm322.2-96.59c-.01-2.1.12-4.09.38-5.97l-21.77-14.54c-3.13-2.09-6.56-4.49-10-6.9-12.38-8.67-25.13-17.6-38.87-21.21-7.42-1.95-15.98-3.25-24.75-3.42-7.64-.14-15.44.58-22.77 2.47-4.38 1.14-8.61 2.71-12.53 4.78-3.49 1.84-6.74 4.1-9.63 6.8l-14.62 17.39c-.44.86-1.07 1.6-1.83 2.17l-40.31 47.97c.6 3.07 1.81 5.64 3.46 7.69 1.92 2.38 4.48 4.15 7.43 5.25 3.12 1.17 6.72 1.62 10.53 1.31 6.08-.51 12.56-2.99 18.41-7.62l11.2-9.26c2.83-2.34 5.19-4.49 7.53-6.64 5.17-4.72 10.34-9.44 15.76-12.67 12.56-7.5 25.06-7.74 37.43 13l63.38 114.32h21.55l.02-134.92zm5.1-18.3c.98-1.36 2.1-2.61 3.36-3.74 5.53-4.98 13.45-7.41 23.61-7.42v-.03l55.1.02c11.53-.05 20.91 2.06 27.4 7.06 7.23 5.56 10.62 14.04 9.17 26.19l-12.18 125.88c-.89 11.24-3.86 20.05-9.15 26.14-5.63 6.47-13.47 9.66-23.74 9.23l-49.55.01c-6.94.36-12.82-1.52-17.74-5.46-3.61-2.87-6.59-6.81-8.98-11.72h-17.14c2.31 6.75 2.19 13.15.35 18.84-1.9 5.85-5.59 10.84-10.3 14.57-4.61 3.66-10.24 6.16-16.12 7.13-5.75.94-11.76.42-17.35-1.9-6.5 6.8-13.35 11.08-20.49 13.05-7.17 1.97-14.43 1.57-21.78-1.01-6.97 7.73-14.68 12.58-23.17 14.42-8.65 1.87-17.85.58-27.59-4.01-3.04 2.37-6.22 4.25-9.53 5.62-4.71 1.95-9.65 2.85-14.8 2.7-12.35-.37-20.67-4.02-27.29-9.94-6.31-5.64-10.56-12.89-15.35-21.23l-27.31-47.64h-21.18c-1.19 5.97-3.24 11.04-6.28 15.11l-.3.42c-5.4 6.94-13.33 10.63-24.29 10.41l-46.21.01c-9.16 1.48-17.01-.76-23.15-7.88-5.44-6.31-9.16-16.51-10.74-31.53l-.07-.55L.69 290.63c-1.89-12.77.2-21.8 5.33-27.97 5.18-6.22 12.98-9.03 22.6-9.48l.8-.05h58.5v.03c9.25-.11 17.19 1.42 23.19 5.3v.02c4.85 3.14 8.33 7.56 10.12 13.57h39.81c10-6.75 19.37-12.05 29.73-15.28 10.17-3.17 21.08-4.28 34.11-2.72l13.62-16.21.51-.54c3.8-3.61 8.05-6.58 12.62-8.99 4.8-2.53 9.96-4.45 15.3-5.83 8.5-2.2 17.46-3.04 26.19-2.88 9.89.18 19.5 1.64 27.8 3.82l.02.01c15.89 4.16 29.62 13.78 42.95 23.12 3.18 2.23 6.35 4.45 9.79 6.74l19.35 12.88zm-283.38 14.14a6.457 6.457 0 0 1-.24-2.33c-.71-4.16-2.53-6.97-5.23-8.72-3.77-2.41-9.36-3.35-16.19-3.27h-.07v.03l-58.75-.01c-6.05.29-10.69 1.74-13.28 4.86-2.79 3.34-3.79 9.11-2.43 18.05l.06.59 9.56 118.61c1.3 12.26 3.94 20.14 7.68 24.48 2.96 3.42 7 4.4 11.85 3.52.39-.07.78-.11 1.16-.11l46.27-.02.69.04c6.48.11 10.97-1.83 13.8-5.47l.23-.28c3.13-4.25 4.67-10.81 4.91-19.21l-.02-130.76zm12.89 129.74h23.64c2.5 0 4.67 1.42 5.74 3.5l29.03 50.63c4.25 7.41 8 13.83 12.73 18.06 4.42 3.95 10.21 6.4 19.09 6.66 3.33.1 6.52-.48 9.56-1.73 1.86-.77 3.69-1.81 5.48-3.11l-18.91-35.39a6.41 6.41 0 0 1 2.64-8.68c3.13-1.67 7.02-.49 8.68 2.64l20.56 38.47c7.66 3.89 14.59 5.1 20.83 3.75 5.7-1.24 11.08-4.66 16.14-10.19l-29.63-46.5a6.422 6.422 0 0 1 1.97-8.86 6.409 6.409 0 0 1 8.85 1.97l31.23 49.01c5.47 2.22 10.73 2.73 15.74 1.36 4.78-1.32 9.57-4.39 14.36-9.34l-28.29-53.25a6.44 6.44 0 0 1 2.66-8.71 6.452 6.452 0 0 1 8.71 2.67l29.26 55.09c3.81 2.2 8.21 2.78 12.45 2.08 3.7-.6 7.26-2.19 10.18-4.5 2.81-2.24 5-5.13 6.07-8.44 1.17-3.63 1.05-7.9-.97-12.54-.42-.96-.59-1.98-.52-2.97a6.418 6.418 0 0 1-3.66-4.25l-64.22-115.85c-7.14-11.94-13.58-12.25-19.8-8.55-4.41 2.63-9.05 6.88-13.7 11.12-2.81 2.57-5.64 5.16-7.98 7.09l-11.4 9.39c-7.94 6.31-16.88 9.7-25.36 10.41-5.63.46-11.13-.26-16.06-2.11-5.1-1.91-9.57-5.02-12.96-9.23-3.66-4.54-6.05-10.29-6.62-17.13-.16-1.97.58-3.79 1.87-5.09l34.71-41.3c-7.38-.1-13.91.91-20.04 2.82-9.35 2.9-18.07 7.99-27.62 14.5a6.45 6.45 0 0 1-3.99 1.38h-40.45v125.12zm321.98-28.99c6.11 0 11.07 4.96 11.07 11.07 0 6.12-4.96 11.07-11.07 11.07-6.12 0-11.08-4.95-11.08-11.07 0-6.11 4.96-11.07 11.08-11.07zm-145.85-249.3c-19.45-.76-35.83 14.38-36.59 33.83-.36 9.02 2.71 17.37 8.03 23.81 17.1-2.74 35.84-1.84 52.74 1.83a35.079 35.079 0 0 0 9.66-22.88c.76-19.45-14.39-35.83-33.84-36.59zM145.94 240.18 262.77 37.83l-19.01-10.78-117.45 203.43c4.41 2.6 8.76 6.05 12.27 9.7h7.36z"/></svg> */}

// investor icon
// <?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 111.09" style="enable-background:new 0 0 122.88 111.09" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M36.25,39.13c-1.13,0.05-1.99,0.28-2.57,0.67c-0.33,0.22-0.58,0.51-0.74,0.85c-0.17,0.38-0.26,0.84-0.24,1.37 c0.05,1.55,0.85,3.58,2.43,5.92l0.02,0.04l0,0l5.11,8.1c2.05,3.25,4.19,6.57,6.86,9.01c2.56,2.34,5.67,3.92,9.78,3.94 c4.45,0.01,7.71-1.64,10.35-4.11c2.75-2.57,4.92-6.1,7.06-9.62l5.74-9.47c1.08-2.44,1.46-4.08,1.21-5.04 c-0.15-0.57-0.77-0.86-1.85-0.9c-0.23-0.01-0.46-0.02-0.7-0.01c-0.26,0.01-0.52,0.03-0.8,0.05c-0.16,0.02-0.3,0-0.44-0.03 c-0.51,0.03-1.04-0.01-1.57-0.08l1.97-8.71c-14.61,2.3-25.53-8.55-40.97-2.17l1.11,10.27C37.38,39.23,36.79,39.21,36.25,39.13 L36.25,39.13L36.25,39.13L36.25,39.13z M122.09,90.14c0.51,0.85,0.79,1.76,0.79,2.71c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.94,0.28-1.85,0.79-2.71c2.2,3.68,8.75,6.35,16.49,6.35C113.35,96.49,119.9,93.82,122.09,90.14 L122.09,90.14L122.09,90.14z M111.84,71.42l-0.2,2.25l-8.48-0.74c0.7,0.89,1.18,1.91,1.45,3.05l-2.04-0.18 c-0.14-0.6-0.45-1.27-0.92-2c-0.48-0.74-1.06-1.26-1.76-1.58l0.16-1.82L111.84,71.42L111.84,71.42L111.84,71.42L111.84,71.42z M105.6,67.9c7.84,0,14.2,2.5,14.2,5.57c0,3.08-6.36,5.57-14.2,5.57c-7.84,0-14.2-2.5-14.2-5.57C91.4,70.39,97.76,67.9,105.6,67.9 L105.6,67.9L105.6,67.9z M105.6,66.05c9.54,0,17.28,4.06,17.28,9.06c0,5-7.74,9.06-17.28,9.06c-9.54,0-17.28-4.06-17.28-9.06 S96.06,66.05,105.6,66.05L105.6,66.05L105.6,66.05z M122.15,81.15c0.47,0.82,0.73,1.7,0.73,2.6c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.91,0.25-1.78,0.73-2.6c2.13,3.73,8.73,6.46,16.55,6.46C113.42,87.61,120.02,84.88,122.15,81.15 L122.15,81.15L122.15,81.15L122.15,81.15z M122.07,99.28c0.53,0.87,0.81,1.79,0.81,2.75c0,5-7.74,9.06-17.28,9.06 c-9.54,0-17.28-4.06-17.28-9.06c0-0.96,0.29-1.88,0.81-2.75c2.22,3.66,8.75,6.31,16.47,6.31 C113.32,105.59,119.84,102.94,122.07,99.28L122.07,99.28L122.07,99.28L122.07,99.28z M60.04,83.04l4.5,15.63 c3.48-7.32,7.11-14.59,7.93-22.9c-1.38-1.62-2.84-3.76-4.11-5.62c-0.38-0.55-0.73-1.07-1.07-1.55c-2.79,2.04-6.13,3.32-10.41,3.3 c-4.61-0.01-8.15-1.65-11.09-4.14c-0.02,0.03-0.04,0.06-0.06,0.09c-0.48,0.66-1.01,1.44-1.59,2.29c-1.08,1.59-2.3,3.37-3.49,4.87 c1.54,9.63,5.24,16.41,8.59,23.64l4.5-15.63C48.08,73.64,65.2,73.1,60.04,83.04L60.04,83.04z M69.08,67.14 c0.36,0.51,0.76,1.1,1.19,1.72c0.79,1.16,1.66,2.44,2.53,3.6c1.68,1.45,4.25,2.58,7.22,3.53C78.08,80.39,77,85.24,77,90.35 c0,7.4,2.26,14.28,6.13,19.98H56.9H6.19c-3.88-0.29-5.85-2.3-6.19-5.78l1.34-6c0.38-4.92,1.76-8.79,4-11.76 c1.48-1.96,3.32-3.4,5.36-4.53c6.07-3.38,21.77-4.51,28.47-9.04c1.05-1.35,2.12-2.94,3.1-4.36c0.6-0.88,1.16-1.7,1.63-2.34 c0.08-0.11,0.17-0.2,0.29-0.28c-2.47-2.54-4.46-5.61-6.35-8.62l-5.1-8.12c-1.87-2.79-2.83-5.32-2.9-7.41 c-0.03-0.98,0.14-1.87,0.5-2.66c0.38-0.82,0.96-1.51,1.76-2.04c0.37-0.25,0.78-0.46,1.24-0.63c-0.33-4.4-0.45-9.95-0.24-14.59 c0.11-1.1,0.32-2.21,0.63-3.3c1.31-4.66,4.58-8.41,8.62-10.98c1.42-0.91,2.99-1.66,4.64-2.26C49.9,4.56,48.48,0.08,51.73,0 c7.62-0.17,20.1,6.27,24.97,11.54c2.83,3.07,4.61,7.12,4.99,12.5l-0.32,13.24l0,0c1.42,0.43,2.32,1.32,2.69,2.78 c0.41,1.61-0.04,3.88-1.4,6.97l0,0c-0.03,0.05-0.05,0.11-0.08,0.17l-5.82,9.58c-2.24,3.69-4.51,7.39-7.56,10.23L69.08,67.14 L69.08,67.14L69.08,67.14z"/></g></svg>

// tenant icon
// <?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 85.855" enable-background="new 0 0 122.88 85.855" xml:space="preserve"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M9.604,85.839V49.135c-1.953,0.751-3.779,0.768-5.297,0.251 c-1.185-0.401-2.186-1.119-2.919-2.044c-0.735-0.926-1.202-2.053-1.344-3.295c-0.217-1.927,0.359-4.104,2.002-6.148l0,0 c0.083-0.099,0.175-0.2,0.284-0.284L49.928,0.46c0.617-0.567,1.569-0.625,2.252-0.092l28.895,22.463 c-4.617,1.998-8.527,5.245-10.865,9.75c-8.404-6.733-17.026-13.538-18.78-14.903c-3.829,2.912-37.154,28.571-37.154,29.654v38.523 L9.604,85.839L9.604,85.839L9.604,85.839z M82.619,72.035c2.97,8.74,15.378,9.059,18.163,0c3.284,2.953,12.998,3.548,16.616,5.563 c1.143,0.64,2.178,1.452,3.005,2.548c0.808,1.065,2.005,3.436,2.477,5.71H60.522c0.472-2.274,1.669-4.645,2.477-5.71 c0.832-1.096,1.862-1.908,3.005-2.548C69.622,75.583,79.336,74.988,82.619,72.035L82.619,72.035L82.619,72.035L82.619,72.035z M80.346,53.927c-0.624,0.026-1.091,0.153-1.416,0.371c-0.183,0.122-0.32,0.279-0.405,0.467c-0.097,0.209-0.143,0.462-0.133,0.751 c0.025,0.854,0.472,1.97,1.34,3.259l0.01,0.021l0,0l2.807,4.466c1.127,1.792,2.31,3.618,3.776,4.958 c1.41,1.29,3.121,2.163,5.384,2.167c2.452,0.005,4.243-0.902,5.699-2.263c1.513-1.417,2.711-3.36,3.883-5.299l3.163-5.213 c0.588-1.345,0.806-2.247,0.669-2.775c-0.081-0.315-0.426-0.467-1.021-0.497c-0.126-0.006-0.253-0.011-0.385-0.006 c-0.143,0.006-0.29,0.016-0.442,0.026c-0.086,0.005-0.166,0-0.243-0.016c-0.279,0.016-0.573-0.005-0.868-0.046l1.086-4.796 c-8.039,1.27-14.052-4.704-22.554-1.192l0.614,5.653C80.97,53.983,80.646,53.974,80.346,53.927L80.346,53.927L80.346,53.927 L80.346,53.927z M105.188,52.917c0.775,0.238,1.278,0.731,1.481,1.533c0.229,0.884-0.021,2.132-0.771,3.837l0,0 c-0.015,0.03-0.03,0.062-0.046,0.091l-3.202,5.273c-1.233,2.029-2.486,4.07-4.156,5.633c-1.73,1.619-3.862,2.701-6.781,2.69 c-2.725-0.005-4.774-1.046-6.455-2.583c-1.623-1.486-2.866-3.406-4.05-5.284l-2.811-4.466c-1.025-1.532-1.564-2.933-1.594-4.08 c-0.016-0.543,0.075-1.03,0.273-1.461c0.208-0.452,0.533-0.827,0.965-1.122c0.202-0.137,0.431-0.254,0.68-0.345 c-0.183-2.421-0.249-5.477-0.132-8.029c0.062-0.604,0.178-1.213,0.345-1.816c0.716-2.563,2.518-4.628,4.745-6.049 c1.229-0.782,2.573-1.375,3.979-1.771c0.889-0.253-0.761-3.106,0.163-3.197c4.461-0.456,11.673,3.614,14.789,6.984 c1.558,1.69,2.537,3.922,2.75,6.881L105.188,52.917L105.188,52.917L105.188,52.917L105.188,52.917z M58.533,54.168 c-0.594,0.323-1.335,0.104-1.655-0.486c-0.323-0.595-0.104-1.336,0.49-1.654c2.808-1.524,4.116-3.494,4.379-5.422 c0.141-1.028-0.02-2.062-0.406-3.019c-0.396-0.969-1.021-1.85-1.814-2.56c-1.544-1.379-3.71-2.106-5.972-1.543 c-0.917,0.228-1.71,0.686-2.405,1.333c-0.738,0.686-1.375,1.583-1.934,2.643c-0.315,0.599-1.053,0.826-1.646,0.515 c-0.599-0.314-0.826-1.053-0.515-1.646c0.686-1.301,1.488-2.417,2.437-3.303c0.994-0.921,2.146-1.583,3.486-1.915 c3.111-0.77,6.075,0.212,8.18,2.094c1.07,0.957,1.918,2.15,2.454,3.466c0.538,1.328,0.758,2.788,0.555,4.267 C63.802,49.578,62.11,52.226,58.533,54.168L58.533,54.168L58.533,54.168z M49.176,63.809c-4.625-6.215-4.738-12.102,0.878-17.573 l-4.044-2.234c-3.239-1.259-9.181,8.029-6.885,10.511l3.151,4.674l-0.65,1.356c-0.179,0.402-0.004,0.685,0.435,0.881l0.427,0.115 l-8.196,16.221l1.659,3.538l3.319-0.978l0.854-1.658l-0.817-1.532l1.802-0.387l0.42-0.813l-0.942-1.437l0.619-1.2l1.799-0.228 l0.585-1.136l-1.005-1.313l0.643-1.244l1.833-0.299l2.498-4.766l0.423,0.231C48.713,64.985,49.092,64.697,49.176,63.809 L49.176,63.809L49.176,63.809z M57.883,67.704l-1.221,4.556l-1.695,0.67l-0.355,1.327l1.236,1.049l-0.322,1.209l-1.675,0.591 l-0.343,1.275l1.2,1.177l-0.231,0.866l-1.647,0.745l1.101,1.297l-0.475,1.767l-2.971,1.623l-2.322-3.043l4.427-16.523l-1.072-0.288 c-0.219-0.059-0.355-0.286-0.295-0.511l0.45-1.678c-3.246-2.462-4.854-6.721-3.737-10.896c1.436-5.364,6.853-8.604,12.221-7.398 c0.024,0.287,0.02,0.578-0.02,0.869c-0.101,0.726-0.416,1.472-0.998,2.193c-0.079,0.097-0.163,0.195-0.25,0.292 c-1.715-0.111-3.322,0.996-3.785,2.72c-0.2,0.742-0.156,1.491,0.079,2.166c0.057,0.239,0.148,0.471,0.269,0.697 c0.282,0.52,0.698,0.913,1.184,1.165c0.319,0.212,0.678,0.37,1.065,0.479c1.926,0.514,3.9-0.594,4.474-2.488 c0.583-0.515,1.089-1.058,1.524-1.616c0.845-1.089,1.423-2.245,1.767-3.421c2.329,2.512,3.354,6.13,2.401,9.688 c-1.117,4.175-4.647,7.063-8.684,7.569l-0.45,1.679c-0.059,0.22-0.288,0.355-0.511,0.296L57.883,67.704L57.883,67.704 L57.883,67.704z M78.216,2.963l14.322,0.584v17.031l-0.626-0.008v0.041c-0.879,0.001-1.762,0.043-2.641,0.125L78.216,13.44V2.963 L78.216,2.963L78.216,2.963L78.216,2.963z"/></g></svg>


// businessman with rupee icon
{/* <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 470.17"><path d="M174.84 253.55c-11.45-10.2-20.5-17.55-22.43-38.71l-1.24.02c-2.83-.03-5.56-.69-8.12-2.14-4.11-2.33-6.98-6.34-8.94-10.86-4.13-9.48-7.38-34.41 2.99-41.55l-1.94-1.28-.22-2.77c-.4-5.01-.51-11.09-.61-17.45-.37-23.44-.85-48.78-19.7-54.47l-8.08-2.46 5.33-6.59c15.23-18.82 31.14-35.28 47.18-47.91C177.22 13.09 195.68 3.57 213.72.83c18.57-2.82 36.56 1.44 53.17 14.87 4.9 3.96 9.67 8.73 14.25 14.31 17.73 1.71 32.22 11.26 42.56 24.87 6.17 8.14 10.86 17.76 13.85 27.98 2.98 10.18 4.28 21.02 3.73 31.69-1.01 19.11-8 34.71-22.08 48.32 2.46.09 4.81.66 6.87 1.76 7.86 4.2 8.11 13.33 6.04 21-2.03 6.4-4.63 13.83-7.08 20.06-2.97 8.42-7.32 9.99-15.72 9.08-.43 20.82-10.05 26.55-23 38.78.54 31.35-112.16 27.66-111.47 0zm187.27 95.95 6.77-15.25h25.53c-1.61-5.41-7.94-8.45-13.24-8.45h-19.06l6.77-15.25h73.06l-6.76 15.25h-17.66c2.35 1.79 4.86 5.49 5.3 8.45h19.12l-6.76 15.25h-13.84c-4.46 11.37-18.08 19.09-29.71 20.76l38.39 39.52h-30.34l-34.23-37.55v-14h15.15c5.16 0 11.57-3.63 13.21-8.73h-31.7zm-193.1-70.13 33.54 88.06 16.85-48-8.27-9.03c-6.21-9.07-4.07-19.38 7.44-21.25 3.88-.62 8.26-.23 12.49-.23 4.46 0 9.45-.42 13.69.51 10.69 2.36 11.8 12.73 6.48 20.97l-8.27 9.03 16.86 48 30.33-88.06c7.45 6.72 15.22 12.14 23.14 16.65 3.42-4.7 7.19-9.12 11.28-13.21 19.86-19.93 47.33-32.24 77.62-32.24 30.25 0 57.7 12.31 77.57 32.17 19.93 19.94 32.24 47.38 32.24 77.64 0 30.29-12.31 57.76-32.17 77.62l-1.1 1.01c-19.78 19.27-46.79 31.16-76.54 31.16-30.3 0-57.76-12.31-77.62-32.17a110.464 110.464 0 0 1-14.49-17.88H0c0-124.09 94.33-73.52 169.01-140.75zm233.18-9.84c50.17 0 90.85 40.68 90.85 90.85 0 50.16-40.68 90.83-90.85 90.83-50.16 0-90.83-40.67-90.83-90.83 0-50.17 40.67-90.85 90.83-90.85z"/></svg> */}


{/* <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="1.70666in" height="1.70666in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 1707 1707" xmlns:xlink="http://www.w3.org/1999/xlink">
 <defs>
  <style type="text/css">
   
    .fil0 {fill:url(#id0)}
   
  </style>
  <linearGradient id="id0" gradientUnits="userSpaceOnUse" x1="0.0944882" y1="853.335" x2="1706.24" y2="853.335">
   <stop offset="0" style="stop-opacity:1; stop-color:#336666"></stop>
   <stop offset="1" style="stop-opacity:1; stop-color:#003333"></stop>
  </linearGradient>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"></metadata>
  <path class="fil0" d="M283 1173l54 -43c-72,-48 -120,-130 -120,-222 0,-148 120,-268 268,-268 147,0 267,120 267,268 0,92 -48,174 -120,222l54 43c153,1 277,103 277,228l0 201c0,15 -12,26 -26,26l-911 0c-14,0 -26,-11 -26,-26l0 -201c0,-127 125,-228 283,-228zm1398 -412l-91 0c57,81 0,193 -99,193 -100,0 -157,-112 -100,-193l-228 0c57,81 -1,193 -100,193 -100,0 -157,-112 -100,-193l-90 0c-13,0 -24,-9 -26,-21l-104 -610 -179 0c-34,0 -34,-52 0,-52l201 0c13,0 24,10 26,22l15 88 720 0c15,0 26,11 26,26l0 412c0,14 -11,26 -26,26l-641 0 10 58 786 0c34,0 34,51 0,51zm-867 -522l14 77 172 0 0 -77 -186 0zm22 129l18 104 146 0 0 -104 -164 0zm27 156l13 76 124 0 0 -76 -137 0zm188 76l208 0 0 -76 -208 0 0 76zm260 0l190 0 0 -76 -190 0 0 76zm190 -128l0 -104 -190 0 0 104 190 0zm0 -156l0 -77 -190 0 0 77 190 0zm-242 -77l-208 0 0 77 208 0 0 -77zm-196 522c-39,0 -71,32 -71,71 0,39 32,71 71,71 39,0 71,-32 71,-71 0,-39 -32,-71 -71,-71zm428 0c-39,0 -71,32 -71,71 0,39 32,71 71,71 39,0 70,-32 70,-71 0,-39 -31,-71 -70,-71zm-232 -289l0 -104 -208 0 0 104 208 0zm-626 725l-51 -40c-62,24 -132,24 -195,0l-54 42 148 118 152 -120zm-581 380l101 0 0 -100c0,-34 52,-34 52,0l0 100 549 0 0 -100c0,-34 51,-34 51,0l0 100 106 0 0 -176c0,-97 -102,-176 -227,-176l-4 0 -183 145c-9,8 -22,8 -32,0l-182 -145 -4 0c-125,0 -227,79 -227,176l0 176 0 0zm433 -885c-119,0 -216,97 -216,216 0,119 97,215 216,215 119,0 215,-96 215,-215 0,-119 -96,-216 -215,-216z"></path>
 </g>
</svg> */}


//clientcontacts
{/* <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 64 64"><circle cx="14.5" cy="24.5" r="9.5" fill="none" stroke="#030303" stroke-miterlimit="10" stroke-width="4"></circle><path fill="none" stroke="#030303" stroke-miterlimit="10" stroke-width="4" d="M1 49A14.74 14.74 0 0 1 15.48 34M29 49A14.74 14.74 0 0 0 14.52 34"></path><line x1="35" x2="63" y1="15" y2="15" fill="none" stroke="#030303" stroke-miterlimit="10" stroke-width="4"></line><line x1="35" x2="63" y1="31" y2="31" fill="none" stroke="#030303" stroke-miterlimit="10" stroke-width="4"></line><line x1="35" x2="63" y1="47" y2="47" fill="none" stroke="#030303" stroke-miterlimit="10" stroke-width="4"></line></svg> */}


const SearchIcon = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-search-icon lucide-search menu-icon"
  >
    <path d="m21 21-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </svg>
);

const DownloadIcon = ({ size = 24, color = "#000000" }) => (
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="lucide lucide-download-icon lucide-download"
>
  <path d="M12 15V3" />
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  <path d="m7 10 5 5 5-5" />
</svg>
);


const LogoIcon = ({ size = 100, color = "#ffd700",backgroundColor="transparent", className = "" ,animate=""}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 1000 1000"
    // className={className}
    // className={`logo ${className}`}
    className={`logo ${animate} ${className}`}
    style={{ backgroundColor }}
  >
    <defs>
      <linearGradient id="linearGradient5">
        <stop offset="0.16834666" stopColor="#0b1100" stopOpacity="1" />
        <stop offset="1" stopColor="#152600" stopOpacity="0" />
      </linearGradient>

      <linearGradient id="linearGradient29">
        <stop offset="0" stopColor="#454545" stopOpacity="0.02159825" />
        <stop offset="0.8471545" stopColor="#272727" stopOpacity="1" />
      </linearGradient>

      <linearGradient id="linearGradient28">
        <stop offset="0" stopColor="#313131" stopOpacity="0.58963281" />
        <stop offset="1" stopColor="#787878" stopOpacity="0" />
      </linearGradient>

      <linearGradient id="linearGradient20">
        <stop offset="0.21138212" stopColor="#000000" />
        <stop offset="1" stopColor="#7b7b7b" stopOpacity="0" />
      </linearGradient>

      <linearGradient id="linearGradient11">
        <stop offset="0" stopColor="#1a1a1a" stopOpacity="0" />
        <stop offset="1" stopColor="#1a1a1a" />
      </linearGradient>

      <linearGradient id="linearGradient3">
        <stop offset="0" stopColor="#000000" />
        <stop offset="1" stopColor="#000000" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="linearGradient4"
        href="#linearGradient3"
        gradientTransform="scale(0.94460977,1.0586382)"
        x1="260.7063"
        y1="180.71242"
        x2="381.77795"
        y2="180.71242"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient10"
        href="#linearGradient20"
        x1="246.64236"
        y1="256.12024"
        x2="353.66599"
        y2="189.43793"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient12"
        href="#linearGradient11"
        x1="353.66599"
        y1="189.43793"
        x2="246.64236"
        y2="256.12024"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient21"
        href="#linearGradient28"
        x1="356.49896"
        y1="256.49722"
        x2="246.35986"
        y2="244.45439"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient30"
        href="#linearGradient29"
        x1="247.91217"
        y1="324.68497"
        x2="294.29575"
        y2="302.82605"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient6"
        href="#linearGradient5"
        x1="136.06044"
        y1="98.646271"
        x2="118.35736"
        y2="193.64775"
        gradientUnits="userSpaceOnUse"
      />

      <linearGradient
        id="linearGradient7"
        href="#linearGradient3"
        gradientTransform="scale(0.94460977,1.0586382)"
        x1="260.7063"
        y1="180.71242"
        x2="381.77795"
        y2="180.71242"
        gradientUnits="userSpaceOnUse"
      />
    </defs>

    <g fill="#ccff00">
      <g
        transform="matrix(2.2127206,0,0,2.2127206,-30.274396,-164.5082)"
      >
        {/* FULL IMAGE → CUSTOM COLOR */}
        <path
          fill={color}
          d="m 341.38575,421.6191 c -39.65854,22.9381 -73.51945,56.70244 -121.2409,59.06952 -33.36471,-3.80074 -45.86542,-27.25582 -55.21858,-78.68491 -6.22645,-54.33404 -2.62907,-139.60584 40.80217,-196.3677 16.90097,-22.28739 39.37119,-41.54865 66.52999,-49.73719 31.37239,-7.88599 11.67466,34.41693 -0.19229,45.57084 -29.50285,37.8781 -76.98044,61.16443 -96.11493,106.9647 -7.8322,26.3369 9.68325,54.36285 34.15124,64.3404 47.01616,21.98824 125.44046,32.16606 140.56776,41.82088 33.97002,17.63423 10.88636,45.46326 -6.34458,60.03032 -13.27079,13.95832 -22.70831,21.27631 -28.68736,30.5388 22.65036,-9.79464 43.7932,-23.70922 62.16856,-40.06148 17.24131,-18.7387 18.82656,-50.47106 0.25582,-68.94492 -20.01973,-22.39993 -48.55974,-34.04147 -73.74553,-49.39732 -17.14265,-9.11531 -34.53072,-17.76293 -51.60667,-27.00458 59.62539,-30.71622 107.70746,-87.27985 111.79578,-154.51874 0.58076,-45.14644 -41.72815,-84.707363 -86.67244,-81.907972 -50.0418,-1.879021 -94.48219,30.109132 -124.91112,67.256032 -36.12187,47.72727 -55.673945,106.55224 -63.104726,165.48855 -7.116351,59.78713 5.046455,126.08784 49.564276,169.56668 22.94195,23.65348 57.94992,39.35628 90.724,28.04471 48.24927,-13.64373 82.74125,-53.09605 111.27953,-92.06662 z"
        />

        {/* FIRST CURVE (NO STROKE) */}
        <path
          fill="url(#linearGradient6)"
          stroke="none"
          d="m 206.56015,110.2142 c -35.24005,18.53394 -65.08711,53.33092 -82.90319,88.2779 -2.05295,7.79798 -7.91304,10.04326 -7.85494,18.48777 1.81813,7.30487 11.25699,6.04256 17.0981,6.11281 11.24763,-1.3294 22.51494,0.15399 33.79484,-0.59169 8.25911,-0.20145 16.53481,-0.37003 24.78341,0.20774 16.19154,-19.28805 23.45479,-30.48009 39.26836,-43.67115 3.94358,-3.28957 8.84705,-6.67189 14.05424,-10.37189 10.50591,-6.49987 22.36167,-12.0137 31.36269,-13.53068 1.38116,-0.23277 2.6541,-0.24287 3.83566,-0.1886 6.68194,0.30692 10.00518,5.09221 8.93285,13.54649 -0.42073,3.31707 -4.21326,13.14878 -6.07987,17.54826 12.81316,-21.8047 16.3916,-34.38792 9.58942,-60.14874 C 280.17777,92.12657 235.9001,90.499044 206.56015,110.2142 Z"
        />

        {/* THIRD CURVE */}
        <path
          fill="url(#linearGradient30)"
          stroke="url(#linearGradient21)"
          d="m 368.11862,438.35228 c 1.69433,-7.69619 -2.44344,-15.17275 -5.98113,-21.76116 -4.34664,-8.43226 -11.83191,-14.4675 -19.71558,-19.41639 -10.12351,-6.53654 -20.437,-12.7877 -31.30832,-18.00803 -10.90332,-5.80702 -21.48283,-12.21872 -32.7998,-17.22085 -10.18449,-4.88766 -20.35902,-9.82003 -30.20113,-15.3745 -1.43123,13.14449 -3.86002,26.99599 0.8251,39.77228 3.82263,4.09023 10.08732,4.38992 15.20408,5.97138 20.57047,4.36976 41.2943,8.24453 61.34711,14.71361 13.26066,4.42944 27.35249,8.79154 37.75072,18.58757 3.78392,3.16462 4.32055,8.16629 4.87895,12.73609 z"
        />

        {/* SECOND CURVE */}
        <path
          fill="url(#linearGradient10)"
          stroke="url(#linearGradient12)"
          d="m 252.71045,319.75646 c -3.78111,-1.24313 -13.58126,-21.15363 4.39677,-35.88294 36.21053,-28.57277 71.99406,-60.78455 103.52396,-92.56446 l -5.12955,16.78946 c -3.31794,9.22068 -3.18814,10.33485 -12.22873,27.10131 -4.78351,8.87139 -10.38568,16.79381 -16.44051,24.35398 -18.70458,23.35485 -43.15487,44.4343 -74.12194,60.20265 z"
        />
      </g>
    </g>
  </svg>
);






const PulsingLogo = ({ 
  size = 500, 
  color = "#ccff00", 
  backgroundColor = "transparent", 
  className = "", 
  animate = "" 
}) => {
  return (
    <div className="flex items-center justify-center">
      <style>{`
        @keyframes colorCycle {
          0%, 100% { fill: ${color}; }
          50% { fill: #00ffaa; }
        }

        @keyframes pulseScale {
          0%, 100% { transform: matrix(2.21, 0, 0, 2.21, -30.27, -164.5); }
          50% { transform: matrix(2.25, 0, 0, 2.25, -40, -175); }
        }

        @keyframes shiftGradient {
          0%, 100% { stop-opacity: 0.8; stop-color: #454545; }
          50% { stop-opacity: 0.2; stop-color: #ccff00; }
        }

        .animate-main-path {
          animation: colorCycle 8s ease-in-out infinite;
        }

        .animate-group {
          animation: pulseScale 6s ease-in-out infinite;
          transform-origin: center;
        }

        .animate-gradient-stop {
          animation: shiftGradient 4s ease-in-out infinite;
        }
      `}</style>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 1000 1000"
        className={`logo ${animate} ${className}`}
        style={{ backgroundColor }}
      >
        <defs>
          <linearGradient id="linearGradient5">
            <stop offset="0.16" stopColor="#0b1100" stopOpacity="1" />
            <stop offset="1" stopColor="#152600" stopOpacity="0" />
          </linearGradient>

          <linearGradient id="linearGradient29">
            <stop className="animate-gradient-stop" offset="0" />
            <stop offset="0.84" stopColor="#272727" stopOpacity="1" />
          </linearGradient>

          <linearGradient id="linearGradient20">
            <stop offset="0.21" stopColor="#000000" />
            <stop className="animate-gradient-stop" offset="1" stopOpacity="0" />
          </linearGradient>

          <linearGradient id="linearGradient10" href="#linearGradient20" x1="246.6" y1="256.1" x2="353.6" y2="189.4" gradientUnits="userSpaceOnUse" />
          <linearGradient id="linearGradient21" href="#linearGradient28" x1="356.4" y1="256.4" x2="246.3" y2="244.4" gradientUnits="userSpaceOnUse" />
          <linearGradient id="linearGradient30" href="#linearGradient29" x1="247.9" y1="324.6" x2="294.2" y2="302.8" gradientUnits="userSpaceOnUse" />
          <linearGradient id="linearGradient6" href="#linearGradient5" x1="136.0" y1="98.6" x2="118.3" y2="193.6" gradientUnits="userSpaceOnUse" />
        </defs>

        <g className="animate-group">
          {/* Main Shape */}
          <path
            className="animate-main-path"
            d="m 341.38575,421.6191 c -39.65854,22.9381 -73.51945,56.70244 -121.2409,59.06952 -33.36471,-3.80074 -45.86542,-27.25582 -55.21858,-78.68491 -6.22645,-54.33404 -2.62907,-139.60584 40.80217,-196.3677 16.90097,-22.28739 39.37119,-41.54865 66.52999,-49.73719 31.37239,-7.88599 11.67466,34.41693 -0.19229,45.57084 -29.50285,37.8781 -76.98044,61.16443 -96.11493,106.9647 -7.8322,26.3369 9.68325,54.36285 34.15124,64.3404 47.01616,21.98824 125.44046,32.16606 140.56776,41.82088 33.97002,17.63423 10.88636,45.46326 -6.34458,60.03032 -13.27079,13.95832 -22.70831,21.27631 -28.68736,30.5388 22.65036,-9.79464 43.7932,-23.70922 62.16856,-40.06148 17.24131,-18.7387 18.82656,-50.47106 0.25582,-68.94492 -20.01973,-22.39993 -48.55974,-34.04147 -73.74553,-49.39732 -17.14265,-9.11531 -34.53072,-17.76293 -51.60667,-27.00458 59.62539,-30.71622 107.70746,-87.27985 111.79578,-154.51874 0.58076,-45.14644 -41.72815,-84.707363 -86.67244,-81.907972 -50.0418,-1.879021 -94.48219,30.109132 -124.91112,67.256032 -36.12187,47.72727 -55.673945,106.55224 -63.104726,165.48855 -7.116351,59.78713 5.046455,126.08784 49.564276,169.56668 22.94195,23.65348 57.94992,39.35628 90.724,28.04471 48.24927,-13.64373 82.74125,-53.09605 111.27953,-92.06662 z"
          />

          {/* Glowing Accents */}
          <path fill="url(#linearGradient6)" d="m 206.5,110.2 c -35.2,18.5 -65,53.3 -82.9,88.2 -2,7.7 -7.9,10 -7.8,18.4 1.8,7.3 11.2,6 17,6.1 11.2,-1.3 22.5,0.1 33.7,-0.5 8.2,-0.2 16.5,-0.3 24.7,0.2 16.1,-19.2 23.4,-30.4 39.2,-43.6 3.9,-3.2 8.8,-6.6 14,-10.3 10.5,-6.4 22.3,-12 31.3,-13.5 1.3,-0.2 2.6,-0.2 3.8,-0.1 6.6,0.3 10,5 8.9,13.5 -0.4,3.3 -4.2,13.1 -6,17.5 12.8,-21.8 16.3,-34.3 9.5,-60.1 C 280.1,92.1 235.9,90.4 206.5,110.2 Z" />
          <path fill="url(#linearGradient30)" stroke="url(#linearGradient21)" d="m 368.1,438.3 c 1.6,-7.6 -2.4,-15.1 -5.9,-21.7 -4.3,-8.4 -11.8,-14.4 -19.7,-19.4 -10.1,-6.5 -20.4,-12.7 -31.3,-18 -10.9,-5.8 -21.4,-12.2 -32.7,-17.2 -10.1,-4.8 -20.3,-9.8 -30.2,-15.3 -1.4,13.1 -3.8,26.9 0.8,39.7 3.8,4 10,4.3 15.2,5.9 20.5,4.3 41.2,8.2 61.3,14.7 13.2,4.4 27.3,8.7 37.7,18.5 3.7,3.1 4.3,8.1 4.8,12.7 z" />
          <path fill="url(#linearGradient10)" stroke="url(#linearGradient12)" d="m 252.7,319.7 c -3.7,-1.2 -13.5,-21.1 4.3,-35.8 36.2,-28.5 71.9,-60.7 103.5,-92.5 l -5.1,16.7 c -3.3,9.2 -3.1,10.3 -12.2,27.1 -4.7,8.8 -10.3,16.7 -16.4,24.3 -18.7,23.3 -43.1,44.4 -74.1,60.2 z" />
        </g>
      </svg>
    </div>
  );
};



export {
    LocalityIcon,
    Dashboard,
    Clients,
    AddClient,
    Users,
    Buildersdata,
    Admindashboard,
    Logout,
    Newpost,
    Profile,
    Inventory,
    Savedlist,
    Inbox,
    Database,
    Rupees,
    Subscription,
    Shareicon,
    SaveIcon,
    RepostIcon,
    DeletepostIcon,
    ClipboardpasteIcon,
    CheckedAllIcon,
    UnCheckedAllIcon,
    DeleteCheckedPosts,
    OCRIcon,
    MenuIcon,
    CancelIcon,

    whatsappIcon,
    CompanyIcon,
    AddressIcon,
    UserNameIcon,
    ClientTypeIcon,
    ColonyInterestIcon,
    WhatsappIcon,
    PhoneIcon,
    EmailIcon,

    ChatIcon,
    BookmarkIcon,
    MapPinIcon,

    BhoomiLogoIcon,
    LogoIcon,
    PulsingLogo,
    
    CircleSpinnerIcon,
    DualRingSpinner,
    DotOrbitSpinner,
    TrailArcSpinner,
    ThreeDotsBounceSpinner,
    BarWaveSpinner,
    BlobMorphSpinner,

    SingleOrbitSpinner,
    MultiOrbitSpinner,
    DualRotationOrbitSpinner,
    MultiOrbitSpinner2,
    MultiOrbitSpinner3,

    ClientsIcon,
    SearchIcon,
    DownloadIcon,
    BasketIcon,
}

